import React from 'react';
import styled from 'styled-components';
import { Case, CaseStatus } from '../../services/buildfire/rdb/cases';
import UnreadNotif from '../common/UnreadNotif';
import { doesCaseHaveUnreadMessage } from '../../util/case';
import StatusBadge from '../case/StatusBadge';
import GenericCaseListItem from '../case/CaseListItem';
import Badge from '../common/Badge';
import Typography from '../common/Typography';
import { useFirebase } from '../../services/firebase';
import useCaseIdParam from '../../hooks/useCaseIdParam';

interface CaseListItemProps {
  case: Case;
}

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledUnreadNotif = styled(UnreadNotif)`
  line-height: 12px;
  margin-left: 6px;
  align-self: center;
`;

const BadgeContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const BadgeContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StatNotif: React.FC<{}> = () => {
  return (
    <BadgeContainer>
      <Badge
        fontColor="var(--ion-color-warning-contrast)"
        backgroundColor="var(--ion-color-warning)"
      >
        <BadgeContent>
          <Typography style={{ textTransform: 'uppercase' }}>Stat</Typography>
        </BadgeContent>
      </Badge>
    </BadgeContainer>
  );
};

const CaseListItem: React.FC<CaseListItemProps> = ({ case: c }) => {
  const { currentUser, isAdmin } = useFirebase();
  const canMessage = currentUser?.uid === c.uid || isAdmin;
  const isUnread =
    canMessage && doesCaseHaveUnreadMessage(c, currentUser!, isAdmin);
  const selectedCaseId = useCaseIdParam();
  return (
    <GenericCaseListItem
      case={c}
      rightHandContent={
        c.status === CaseStatus.SIGNED_OFF || c.status === CaseStatus.CLOSED ? (
          <StatusContainer>
            <StatusBadge status={c.status} isAdmin={isAdmin} uniformWidth />
          </StatusContainer>
        ) : c.priority && c.status === CaseStatus.OPEN ? (
          <StatNotif />
        ) : (
          <StatusContainer>
            <StatusBadge status={c.status} isAdmin={isAdmin} uniformWidth />
          </StatusContainer>
        )
      }
      currentUser={currentUser!}
      isUnread={isUnread}
      UnreadNotifComponent={StyledUnreadNotif}
      selected={c.id === selectedCaseId}
      isAdmin={false}
    />
  );
};

export default CaseListItem;
